import { useRewardPoolAccessPoliciesQuery } from '@shared/hooks/query/rewardPools';

import { RewardPool } from '@api/types/rewardPools';

import { mapAccessPoliciesToRequirements } from './mapAccessPoliciesToRequirements';

export const useRequirements = (pool: RewardPool) => {
  const query = useRewardPoolAccessPoliciesQuery(pool.id);

  const { data: policies = [] } = query;

  const requirements = mapAccessPoliciesToRequirements(policies);

  const qualifiedRequirementsCount = requirements.reduce(
    (acc, requirement) => acc + Number(requirement.qualified),
    0,
  );
  const qualifiedAtLeastOneRequirement = qualifiedRequirementsCount > 0;
  const qualifiedAllRequirements = qualifiedRequirementsCount === requirements.length;
  const qualifiedEnoughRequirements =
    pool.access_policy.operator === 'OR'
      ? qualifiedAtLeastOneRequirement
      : qualifiedAllRequirements;

  return {
    requirements,
    hasRequirements: Boolean(requirements.length),
    qualifiedAllRequirements,
    qualifiedAtLeastOneRequirement,
    qualifiedEnoughRequirements,
    qualifiedRequirementsCount,
    query,
  };
};
